import { render, staticRenderFns } from "./RemittanceFooter.vue?vue&type=template&id=475e255a&scoped=true"
import script from "./RemittanceFooter.vue?vue&type=script&lang=js"
export * from "./RemittanceFooter.vue?vue&type=script&lang=js"
import style0 from "./RemittanceFooter.vue?vue&type=style&index=0&id=475e255a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e255a",
  null
  
)

export default component.exports